/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "BandRouteLiveMapService";
const log: any = LoggerModule.getInstance();

export class BandRouteLiveMapService {
  private static instance: BandRouteLiveMapService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private token: string;
  private agent: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
    this.agent = getAgent();
  }

  public static getInstance(props: any = {}): BandRouteLiveMapService {
    if (!BandRouteLiveMapService.instance) {
      BandRouteLiveMapService.instance = new BandRouteLiveMapService(props);
    }
    return BandRouteLiveMapService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentations() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationsProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getBandInitials() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getBandInitialProps();
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getBandRoute(args: any) {
    log.info(`invite user`, args);
    const agent = getAgent();
    return agent.getBandRouteProps(args);
  }

  public onUpdate(callback: any): () => void {
    const result = this.agent.onUpdate(callback);
    return typeof result === "function" ? result : () => {};
  }

  public onConnectionChange(callback: any): () => void {
    const result = this.agent.onConnectionChange(callback);
    return typeof result === "function" ? result : () => {};
  }

  public subscribeToLiveBands() {
    return this.agent.subscribeToLiveBands();
  }
}
